/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 700 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ankit Shakya",
  title: "Hi, I'm Ankit",
  subTitle: emoji(
    "Passionate Software Engineer and a lifelong learner here, turning code and designs into magic! Ready to bring my enthusiasm and skills to projects that push boundaries and create exceptional software. Let's innovate together! 🚀"
  ),
  resumeLink:
    "https://rxresu.me/shakyaankitt001/ankit-shakya-software-engineer", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ShakyaAnkit",
  linkedin: "https://www.linkedin.com/in/ankit-shakya-9b30a919b/",
  gmail: "shakyaankitt001@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "I specialize in crafting secure, scalable web apps and APIs using Python, JavaScript, Django and Flask.",
  skills: [
    emoji(
      "Design and develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("Develop restful APIs using Django and Flask"),
    emoji(
      "Integration of third party services and application"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "postgresql",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "mongodb",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Sunshine Coast",
      logo: require("./assets/images/usc_logo.jpg"),
      subHeader: "Master of Information and Communication Technology",
      duration: "Feb 2024 - Nov 2025",
      desc: "",
      descBullets: []
    },
    {
      schoolName: "Kurukshetra University",
      logo: require("./assets/images/Kurukshetra_University_logo.png"),
      subHeader: "Bachelor of Technology in Computer Science",
      duration: "Feb 2015 - March 2019",
      desc: "",
      descBullets: []
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Deployment",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer Intern",
      company: "Jaimee",
      companylogo: require("./assets/images/company-jaimee.jpeg"),
      companylink: "https://www.jaimee.ai",
      date: "July 2025 – Present",
      desc: "",
      descBullets: [
        "Architected a RAG pipeline with PostgreSQL vector DB using LangChain, integrating OpenAI and Anthropic LLMs for context-aware AI responses.",
        "Designed RESTful API schemas and AWS cloud infrastructure, enabling scalable microservices for production-ready applications."
      ]
    },
    {
      role: "Associate Software Engineer",
      company: "Logpoint",
      companylogo: require("./assets/images/logpoint.jpg"),
      companylink: "https://www.logpoint.com/",
      date: "Oct 2022 – Feb 2024",
      desc: "",
      descBullets: [
        "Developed and maintained log-fetching plugins for Salesforce, AWS, Google Cloud, and Azure.",
        "Refactored UniversalRestAPIFetcher, delivering three improved versions with enhanced performance.",
        "Integrated STIX/TAXII 2.1 threat intelligence into the ThreatIntelligence application.",
        "Migrated Logpoint services to AWS Cloud, improving scalability and deployment flexibility."
      ]
    },
    {
      role: "Django Developer",
      company: "Prixa",
      companylogo: require("./assets/images/prixa.jpg"),
      companylink: "https://prixa.net/",
      date: "Dec 2020 - Aug 2022",
      desc: "",
      descBullets: [
        "Built secure REST APIs and appointment systems for hospital networks",
        "Developed real-time monitoring and alerting tools for web platforms",
        "Engineered high-performance news portals handling 50k+ daily users",
        "Designed a notice system for Nepal government tenders and public information"
      ]
    },
    {
      role: "Frontend Intern",
      company: "CartoonMango",
      companylink: "https://www.cartoonmango.com/",
      companylogo: require("./assets/images/cartoonmango.jpg"),
      date: "April 2019 - Sep 2019",
      desc: "",
      descBullets: [
        "Learned responsive design principles and frontend frameworks",
        "Converted business requirements into intuitive web interfaces",
        "Gained experience with version control and collaborative development tools",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
      projectName: "Localstack + Terraform AWS cloud infrastructure",
      projectDesc: "Implemented a local AWS cloud environment using LocalStack, Docker, AWS CLI, and Terraform. The setup provisions 100 AWS instances locally, enabling cloud application development and testing without incurring AWS costs.",
      footerLink: [
        {
          name: "Link to Project",
          url: "https://github.com/ShakyaAnkit/terraform-localstack-aws-dev"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: "https://www.wvi.org/sites/default/files/styles/social_preview_square/public/2024-10/Sikka%20hero%20image.jpg?itok=VZhDeLzu",
      projectName: "Sikka",
      projectDesc: "Sikka is a blockchain-based platform that streamlines cash and voucher assistance programs. It issues secure digital tokens via SMS, redeemable at authorized merchants, ensuring transparency, traceability, and efficient last-mile aid distribution.",
      footerLink: [
        {
          name: "Learn More",
          url: "https://www.wvi.org/publications/brochure/nepal/sikka-cash-and-voucher-assistance"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Microsoft Certified: Azure AI Fundamentals",
      subtitle:
        "Completed Certifcation from Microsoft for Azure AI Fundamentals",
      image: require("./assets/images/azure-ai-fundamentals.png"),
      imageAlt: "Microsoft Certified: Azure AI Fundamentals Badge",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/08f654e9-70fb-4bec-b92e-4bb25639e138/linked_in_profile"
        }
      ]
    },
    {
      title: "Microsoft Certified: Azure Data Fundamentals",
      subtitle:
        "Completed Certifcation from Microsoft for Azure Data Fundamentals",
      image: require("./assets/images/azure-data-fundamentals-600x600.png"),
      imageAlt: "Microsoft Certified: Azure Data Fundamentals Badge",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/be4f7aef-34a4-4b47-801b-6be7e7b3f843"
        }
      ]
    },
    {
      title: "IT Specialist - Python",
      subtitle:
        "Completed Certifcation for IT Specialist - Python",
      image: require("./assets/images/ITS-Badges_Python_1200px.png"),
      imageAlt: "ITS-Badge-Python",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/0978f8d0-ad2a-4d6f-8b53-24a2daa91898/public_url"
        }
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "Microsoft Certified: Power Platform Fundamentals",
      subtitle:
        "Completed Certifcation from Microsoft for Power Platform Fundamentals",
      image: require("./assets/images/CERT-Fundamentals-Power-Platform.png"),
      imageAlt: "Microsoft Certified: Power Platform Fundamentals Badge",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/89a9c73a-510f-48ff-93d0-e689a6c0fae8/linked_in_profile"
        }
      ]
    },

    {
      title: "Microsoft Certified: Security, Compliance, and Identity Fundamentals",
      subtitle: "Completed Certifcation from Microsoft for Security, Compliance, and Identity Fundamentals",
      image: require("./assets/images/security-compliance-and-identity-fundamentals-600x600.png"),
      imageAlt: "Microsoft Certified: Security, Compliance, and Identity Fundamentals",
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/badges/f76c5d5b-be15-431c-b826-a18f498ccfd4/linked_in_profile"},
        // {
        //   name: "Final Project",
        //   url: "https://pakistan-olx-1.firebaseapp.com/"
        // }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+61 4490-94743",
  email_address: "shakyaankitt001@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
